import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SetInitialStateFacade } from '../../../../../../common/models';
import { UliItemInitialState, UliItemSetUliId } from './uli-item.actions';
import { Observable } from 'rxjs';
import { UliItemState } from './uli-item.state';
import { UliItemActionParams } from '../models/uli-item-overview.model';
import { UliItemStateModel } from './uli-item.state';

@Injectable({ providedIn: 'root' })
export class UliItemFacade implements SetInitialStateFacade {
  uliIdentifiers$: Observable<UliItemStateModel> = this.store.select(UliItemState.getState);
  uli$: Observable<string> = this.store.select(UliItemState.getUliId);
  loaded$: Observable<boolean> = this.store.select(UliItemState.getLoaded);

  constructor(private store: Store) {}

  loadAll(uli: UliItemActionParams): void {
    this.store.dispatch(new UliItemSetUliId(uli));
  }

  setInitialState(): void {
    this.store.dispatch(new UliItemInitialState());
  }
}
